import { render, staticRenderFns } from "./TheRighthandSidebarMenu.vue?vue&type=template&id=305e55d2&scoped=true&"
import script from "./TheRighthandSidebarMenu.vue?vue&type=script&lang=js&"
export * from "./TheRighthandSidebarMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "305e55d2",
  null
  
)

export default component.exports